import Bugsnag from '@bugsnag/js';
import { ClinicReview, Professional, ProfessionalType } from 'app/types/clinic';

export default class clinicService {
  static async getProfessionalsByClinic(
    id: string,
    professionalType: ProfessionalType
  ): Promise<Professional[]> {
    // eslint-disable-next-line no-useless-catch
    try {
      let url = `${process.env.NEXT_PUBLIC_CLINICS_API}Clinics/${id}`;
      if (professionalType !== ProfessionalType.All) {
        url += `?professionalType=${professionalType}`;
      }
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        return data as Professional[];
      } else {
        Bugsnag.notify('Error getProfessionalsByClinic' + res);
        return [];
      }
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Error getProfessionalsByClinic: ' + String(err));
      Bugsnag.notify(error, event => {
        event.addMetadata('request', { clinicId: id, professionalType });
      });
      return [];
    }
  }

  static async getClinics() {
    try {
      const url = `${process.env.NEXT_PUBLIC_CLINICS_API}Clinics`;
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        return data;
      } else {
        Bugsnag.notify('Error getClinics' + res);
        return [];
      }
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Error getting clinics: ' + String(err));
      Bugsnag.notify(error, event => {
        event.addMetadata('request', { endpoint: 'Clinics' });
      });
      return [];
    }
  }
  static async getReviews(): Promise<ClinicReview[]> {
    try {
      const url = `${process.env.NEXT_PUBLIC_CLINICS_API}Clinics/Reviews`;
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        return data;
      } else {
        Bugsnag.notify('Error getClinics' + res);
        return [];
      }
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Error getting clinic reviews: ' + String(err));
      Bugsnag.notify(error, event => {
        event.addMetadata('request', { endpoint: 'Clinics/Reviews' });
      });
      return [];
    }
  }
}
